import { formatColumnLabel } from "../../../../../helper/columnLabel";

export const dataForSort = {
  eta: ["Oldest to Newest", "Newest to Oldest"],
  status: ["Ascending", "Descending"],
};

export const dateFields = [
  "eta",
  "etd",
  "ata",
  "atd",
  "order date",
  "create date",
  "pick date",
  "created date",
  "estimated_date",
  "required date",
  "from",
  "to",
  "date",
  "credit date",
  "validity date",
  "expiry date",
  "requested ship date",
  "due date",
  "posting date",
  "date paid",
  "planned start",
  "required by",
  "est completion",
  "date of transaction",
  "date of creation",
];

export const nameOfFields = {
  "order name": "user_reference",
  eta: "eta",
  "req date": "eta",
  "order date": "date_of_creation",
  "date of transaction": "date_of_creation",
  quantity: "qty",
  soh: "stock_qty",
  product: "product",
  facility: "warehouse",
  "to facility": "to_warehouse",
  "from facility": "from_warehouse",
  status: "status",
  name: "name",
  "eta date": "estimated_date",
  "create date": "create_date",
  "created date": "date_of_creation",
  supplier: "supplier",
  "created by": "creator",
  "erp supplier": "erp_supplier",
  "consolidation status": "consolidation_status",
  "allocatable qty": "allocatable",
  "allocated qty": "allocated_qty",
  "dispatched qty": "dispatched_qty",
  "required qty": "ordered_qty",
  "allocated value": "allocated_value",
  "allocated cbm": "allocated_cbm",
  code: "code",
  number: "number",
  from: "from_date",
  to: "to_date",
  "from quantity": "from_qty",
  "to quantity": "to_qty",
  price: "price",
  "stock zone": "stock_zone",
  "acquisition type": "acquisition_code",
  "planning policy": "planning_policy",
  reason: "reason",
  impact: "impact",
  "other costs type": "landed_cost_type",
  "account type": "type",
  currency: "currency",
  "enable payments to account": "enable_payments_to_account",
  "show in expense claim": "show_in_expense_claims",
  "term type": "term_type",
  "due days": "due_days",
  "month offset": "months_offset",
  jurisdiction: "jurisdiction",
  "bill no": "name",
  // Receipt Adjustment list: "RECEIPT NO" is the source receipt (adjusted_from).
  // Receipt list overrides this in ListView selectValue to use name instead.
  "receipt no": "adjusted_from",
  "shipment no": "shipment_number",
  "shipment number": "shipment_number",
  "document number": "document_number",
  "document no": "document_number",
  "receipt adjustment no": "name",
  "supplier reference": "reference_no",
  "bill date": "create_date",
  "due date": "due_date",
  application: "external_system",
  date: "start_time",
  "credit date": "credit_date",
  "credit no": "name",
  "replenish no": "name",
  account: "account",
  "posting date": "posting_date",
  "date paid": "date_paid",
  "company id": "business_identifier",
  type: "type",
  "sub type": "sub_type",
  email: "email",
  "display name": "display_name",
  "tax category name": "name",
  "tax category": "tax_category",
  "product tax classification name": "name",
  "customer segment name": "name",
  category: "category",
  scope: "scope",
  "pricelist name": "name",
  "quote number": "name",
  "picklist no": "name",
  customer: "display_name",
  "validity date": "validity_date",
  "discount type": "discount_type",
  "expiry date": "validity_date",
  "sales no": "name",
  "pack no": "name",
  "asn no": "name",
  "delivery no": "name",
  "return no": "name",
  "invoice no": "name",
  salesperson: "assigned_to",
  total: "total_amount",
  "requested ship date": "requested_ship_date",
  "equipment type": "equipment_type",
  "shipment name": "shipment",
  location: "location",
  role: "role",
  "co manufacturer": "is_co_manufacturer",
  "bom no": "name",
  "payment no": "name",
  "prepayment no": "name",
  reference: "reference",
  "payment type": "payment_type",
  "payment status": "payment_status",
  payments: "total_payments_allocated",
  outstanding: "payment_outstanding",
  "po total": "total_amount",
  "bank account": "bank_account_dummy",
  country: "country",
  "destination whs": "destination_warehouse",
  "co-manf": "co_manufacturer",
  "co-manf whs": "co_manufacturer_warehouse",
};

export const booleanField = ["co manufacturer"];

export const qtyVal = [
  "allocatable qty",
  "allocated qty",
  "dispatched qty",
  "allocated value",
  "required qty",
  "allocated cbm",
  "from quantity",
  "to quantity",
  "price",
  "due days",
  "month offset",
  "credit limit amount",
  "weight",
  "length",
  "width",
  "height",
  "po total",
  "payments",
  "outstanding",
];

// qurery params name map for search and filter, as the API may have different query params for different fields

export const queryParamsName = {
  "discount type": "discount_type",
  "sales no": "sale_order_ids",
  "sales orders": "sales_orders",
  "bom no": "names",
  "picklist no": "names",
  customer: "customer_ids",
  customers: "customers",
  type: "types",
  status: "status_ids",
  "rep status": "rep_statuses",
  facility: "warehouse_ids",
  "pack no": "names",
  "delivery no": "names",
  "return no": "names",
  "supply facility": "warehouse_ids",
  name: "names",
  code: "codes",
  product: "product_ids",
  "mo no": "names",
  "co-manf no": "names",
  "co-manf": "co_manufacturer_ids",
  "co-manf whs": "co_manufacturer_warehouse_ids",
  priority: "priority_ids",
  "destination whs": "destination_warehouse_ids",
  "manf no": "manufacturing_order_names",
};

// sugest name for headerNameForQueryParams
export const selectedHeadersForQueryParams = Object.keys(queryParamsName);

export const BOOLEAN_FIELD_FOR_FILTER = [
  { id: true, name: "Yes" },
  { id: false, name: "No" },
];

export const orderingFieldByModule = {
  users: {
    name: "full_name",
    email: "email",
    company: "company",
    partner: "supplier",
    "last login": "last_login",
    joined: "date_of_creation",
    status: "status",
  },
  purchaseAllocation: {
    "order name": "user_reference",
  },
  shopifyLinkedProducts: {
    product: "name",
    "shopify product": "shopify_title",
    "shopify available": "shopify_available",
    "shopify on hand": "shopify_on_hand",
    "on order": "on_order_qty",
    "next eta": "next_eta",
  },
  purchase: {
    "order name": "user_reference",
    "create date": "create_date",
    eta: "estimated_date",
    status: "status",
    type: "type",
    supplier: "supplier_id",
    facility: "warehouse_id",
    "po total": "total_amount",
    payments: "total_payments_allocated",
    outstanding: "payment_outstanding",
    "payment status": "payment_status",
  },
  asn: {
    "asn no": "name",
    "shipment no": "consignment__name",
    "order date": "date_of_creation",
    "created by": "created_by__first_name",
    status: "status",
  },
  salesRep: {
    "full name": "full_name",
    "created by": "created_by",
    "create date": "date_of_creation",
    "rep status": "is_active",
  },
  paymentTerm: {
    name: "name",
    "term type": "term_type",
    "due days": "due_days",
    "month offset": "months_offset",
    active: "is_active",
    default: "is_default",
    "created by": "created_by",
  },
  billChargeType: {
    name: "name",
    "amount type": "amount_type",
    "distribution type": "distribution_type",
    "unit price": "unit_price",
    "is landed cost": "is_landed_cost",
    "created by": "created_by",
    "date of creation": "date_of_creation",
  },
  journalLine: {
    "account code": "account__code",
    "account name": "account__name",
    amount: "amount",
    "create date": "date_of_creation",
  },
  receipt: {
    "receipt no": "name",
    "document number": "document_number",
    "document type": "document_type",
    status: "overall_status",
    "shipment number": "shipment_number",
    shipment: "shipment",
    "to facility": "to_warehouse",
    "posting date": "posting_date",
    "created by": "created_by",
  },
  receiptAdjustment: {
    "receipt adjustment no": "name",
    "receipt no": "adjusted_from",
    "document no": "document_number",
    "document type": "document_type",
    status: "overall_status",
    "shipment no": "shipment",
    "posting date": "posting_date",
    "created by": "created_by",
  },
  shopifyCatalogue: {
    product: "sku",
    pricelist: "pricelist_name",
    "available stock": "available_stock",
    "allow backorder": "allow_backorder",
    status: "listed",
    warehouses: "locations",
  },
  equipmentType: {
    name: "name",
    code: "code",
    category: "category",
    "created by": "created_by",
    "create date": "date_of_creation",
  },
  equipment: {
    "equipment type": "equipment_type",
    number: "number",
    "created by": "created_by",
    "create date": "date_of_creation",
  },
  supplier: {
    name: "name",
    code: "code",
    "co manufacturer": "is_co_manufacturer",
    email: "email",
    contact: "contact_number",
    address: "address",
    currency: "currency",
    "payment terms": "payment_term",
    "created by": "created_by",
  },
  shipmentLeg: {
    sequence: "sequence",
    status: "status",
    type: "leg_type",
    "transport mode": "transport_mode",
    eta: "estimated_arrival_at",
    etd: "estimated_departure_at",
    ata: "actual_arrival_at",
    atd: "actual_departure_at",
    "shipment name": "shipment",
    carrier: "carrier",
    "vehicle / vessel": "vehicle_reference",
    origin: "origin",
    destination: "destination",
    "deliver to": "deliver_to",
  },
  manufacturingOrder: {
    "mo no": "name",
    status: "status",
    "planned start": "planned_start",
    "production quantity": "production_qty",
    "required by": "required_by",
    "est completion": "estimated_completion",
  },
  coManufacturingOrder: {
    "co-manf no": "name",
    eta: "eta",
    priority: "priority",
    status: "status",
  },
  manufacturingOrderAllocation: {
    "manf no": "manufacturing_order",
    product: "product",
    facility: "warehouse",
  },
  inventory: {
    product: "product",
    facility: "facility",
    sellable: "sellable",
    allocated: "allocated",
    reserved: "reserved",
    "on hold": "on_hold",
    rejected: "rejected",
    total: "total",
    nsp: "nsp",
    "avg cost": "average_cost",
    "stock value": "stock_value",
  },
  inventoryDetail: {
    product: "product",
    facility: "facility",
    quantity: "qty",
    allocated: "allocated_qty",
    allocatable: "allocatable_qty",
    "unit cost": "unit_price",
    "other costs": "landed_cost",
    "total landed costs": "total_unit_price",
    "batch no": "batch_number",
    "serial no": "lot_number",
    location: "location",
    zone: "zone",
    status: "status",
    "create date": "date_of_creation",
  },
  inventoryTransactions: {
    product: "product",
    facility: "facility",
    quantity: "quantity",
    soh: "soh",
    reason: "reason",
    reference: "reference",
    "date of transaction": "date_of_creation",
  },
  warehouse: {
    name: "name",
    code: "code",
    site: "site",
    country: "country",
    "short description": "short_description",
    "long description": "long_description",
    "created by": "created_by",
    state: "state",
    address: "address",
    "transit air": "local_transit_time_buffer_air",
    "transit ocean": "local_transit_time_buffer_ocean",
  },
  warehouseCosting: {
    product: "product",
    supplier: "supplier",
    "from facility": "from_warehouse",
    "to facility": "to_warehouse",
    "from quantity": "from_qty",
    "to quantity": "to_qty",
    price: "price",
    "created by": "created_by",
    "create date": "date_of_creation",
  },
};

/**
 * Visible list column title for a module header key.
 *
 * @param {string} headerUpperCase
 * @param {Object<string, string>} [moduleOverrides] Renames applied before formatting.
 * @returns {string}
 */
export const getListHeaderDisplayLabel = (headerUpperCase, moduleOverrides = {}) =>
  formatColumnLabel(moduleOverrides?.[headerUpperCase] || headerUpperCase);

/**
 * Query keys to drop when clearing one column filter.
 * Keys still used by another applied column stay — Product and Product name
 * both send ``product_ids``, so clearing one must not wipe the other.
 *
 * @param {object} args
 * @param {string} args.headerName Column being cleared.
 * @param {Object<string, {isApplied?: boolean, paramKeys?: string[]}>} [args.isAppliedFilter]
 * @param {string[]} [args.storedKeys] Query keys owned by the cleared column.
 * @return {string[]}
 */
export function keysToRemoveOnClearFilter({ headerName, isAppliedFilter, storedKeys }) {
  const keys = Array.isArray(storedKeys) ? storedKeys : [];
  const stillUsed = new Set();
  Object.entries(isAppliedFilter || {}).forEach(([header, meta]) => {
    if (header === headerName || !meta?.isApplied) return;
    (meta.paramKeys || []).forEach(key => stillUsed.add(key));
  });
  return keys.filter(key => !stillUsed.has(key));
}
